import { Loader as SemanticLoader } from 'semantic-ui-react';

const Loader: React.FC = () => {
  return <SemanticLoader active>Loading...</SemanticLoader>;
};

export default Loader;
